
/// <reference path="../../lib/tsd.d.ts" />

import {Options, ReceiverInterface} from "./receiver";
import {Collection} from "../lib/event-interface";
import {JoinedRoomModeSpecific} from "../chatserver/sx-server";
import logging from "../utils/log";

declare const Modernizr;

interface NanoPlayerConfig
{
	source: {
		h5live: {
			server: {
				websocket : string;
				progressive ?: string;
				hls ?: string;
			};
			token ?: string;
			rtmp : {
				url: string;
				streamname : string;
			};
		};
		bintu ?: any;
		hls ?: any;
	};
	playback ?: {
		autoplay ?: boolean;
		muted ?: boolean;
		metadata ?: boolean;
		forceTech ?: string;
		videoId ?: string;
	}
	style ?: {
		width ?: string;
		height ?: string;
		aspectratio ?: string;
		controls ?: boolean;
		interactive ?: boolean;
		view ?: boolean;
		scaling ?: "letterbox" | "fill" | "crop" | "original" | "resize";
		keepFrame ?: boolean;
		displayAudioOnly ?: boolean;
	}
	events: {
		onReady ?: (e : any) => void;
		onPlay ?: () => void;
		onPause ?: (e : any) => void;
		onLoading ?: () => void;
		onStartBuffering ?: () => void;
		onStopBuffering ?: () => void;
		onError ?: (e : any) => void;
		onMetaData ?: (e : any) => void;
		onStats ?: (e : any) => void;
		onMuted ?: () => void;
		onUnmuted ?: () => void;
		onVolumeChange ?: () => void;
		onStreamInfo ?: (e : any) => void;
	}

	tweaks ?: any;
}

declare class NanoPlayer
{
	constructor(div : string);
	destroy();

	setVolume(vol : number);
	play();
	stop();
	pause();
	mute();
	unmute();

	setup(config : NanoPlayerConfig)

	static capabilities : any[];
}

export class H5LReceiver implements ReceiverInterface
{
	private isPaused: boolean = true;

	getCurrentName(): string
	{
		return "H5LReceiver";
	}

	setFlag(s: string, enabled : boolean = false): void
	{
		this.$container[enabled ? "addClass" : "removeClass"](s);
	}

	currentStream: string;

	private TAG = "[Sxc.Chat.H5LReceiver]";

	private playerIdNumber = 0;
	private playerID = "";

	private $container : JQuery;
	private player : NanoPlayer;

	private initialized = false;
	private ready       = false;

	private lastAddress : string;
	private lastServer : string;
	private lastStream : string;

	private muteForced : boolean = false;
	private volume : number = null;

	public evt : Collection;
	private currentServer: string;

	constructor (private params : Options)
	{
		this.evt = new Collection("receiver");
	}

	public static isSupported()
	{
		const h264 = "Modernizr" in window ? (Modernizr.video && Modernizr.video.h264) : true;
		return h264 && NanoPlayer.capabilities && NanoPlayer.capabilities.indexOf("h5live") > -1;
	}

	public connect()
	{
		// Nothing
	}

	public getConfig(serverAddress : string, streamName : string) : NanoPlayerConfig
	{
		const t = this;

		let onPlayOnce = false;

		const usePrefix = !("ignoreAAC" in window && window["ignoreAAC"]);
		let streamName2 = usePrefix ? "aac_" + streamName : streamName;

		logging.log(this.TAG, "Playing stream: ", streamName2);

		return {
			source: {
				h5live: {
					// @TODO itt a replace csak teszt miatt van benne, ezt majd ki kell venni
					server: {
						websocket: this.params.h5l.websocket,
						// hls: this.params.h5l.hls,
						progressive: this.params.h5l.progressive
					},
					rtmp: {
						url: serverAddress,
						streamname: streamName2
					}
				}
			},
			playback: {
				autoplay: true, // On purpouse :)
				metadata: false,
				forceTech: "h5live",
			},
			style: {
				controls: false,
				interactive: false,
				view: false,
				scaling: "fill",
				keepFrame: true,
				width: "100%",
				height: "100%",
			},
			//
			tweaks : {
				buffer: {
					min: 0.2,
					start: 0.5,
					max: 8.0,
					target: 1.2,
					limit: 1.7
				},

				// buffer: {
				// 	min: 0.3,
				// 	start: 0.5,
				// 	target: 1,
				// 	limit: 1,
				// 	max: 2,
				// }
			// 	// buffer: {
			// 	// 	min: 10,
			// 	// 	start: 30,
			// 	// 	target: 30,
			// 	// 	limit: 50,
			// 	// 	max: 100,
			// 	// }
			},


			events: {

				onPlay()
				{
					this.isPaused = false;
					if (onPlayOnce) return;
					onPlayOnce = true;
				},

				onReady(e) {
					try {
						t._onPlaying();
					} catch (e) {
						logging.error(t.TAG, "onPlay event handler failed", e, e.toString());
						throw new Error("onPlay event handler failed:" + e.toString)
					}
				},

				onError(e)
				{
					//logging.error(t.TAG, "play:onError", e);

					try {
						let err = JSON.parse(e);
						if (err === '{}') {
							err = e.message;
						}
						e = err;
					} catch (err) { }

					if (e && "data" in e && "code" in e.data && (e.data.code == 1004 || e.data.code == 1005)) {
						//logging.log("Ignoring pause fail event", e);
						return;
					}

					t._onPlayFailed({reason: "nanoPlayerError", data: e, stream: {server: t.currentServer, stream: t.currentStream}});
				},

				onMetaData(e) {
					logging.log(t.TAG, "play:onMetaData", e);
				},

				onStreamInfo(e)
				{
					logging.log(t.TAG, "play:onStreamInfo", e);

					try {
						t.$container.find(".sxccs-nanoplayer").each((i, e) => {
							if (e && e.getAttribute("id") === t.playerID) return;
							$(e).remove();
						});

						let w = e.data.streamInfo.videoInfo && e.data.streamInfo.videoInfo.width;
						let h = e.data.streamInfo.videoInfo && e.data.streamInfo.videoInfo.height;

						if (w && h) {
							t._onVideoDimension(w, h)
						}
					} catch (e) {
						logging.error(t.TAG, "onStreamInfo event handler failed", e, e.toString());
						throw new Error("onStreamInfo event handler failed:" + e.toString)

					}
				},

				onLoading() {
					logging.log(t.TAG, "play:onLoading");
				},

				onStartBuffering() {
					logging.log(t.TAG, "play:onStartBuffering");
				},
				onStopBuffering() {
					logging.log(t.TAG, "play:onStopBuffering");
				},
				onStats(stat) {
					//F logging.log(t.TAG, "play:onStats", stat);
				},
				onPause(e) {

					this.isPaused = true;

					logging.log(t.TAG, "play:onPause", e);

					switch (e.data.reason)
					{
						case "servernotfound":
						case "streamnotfound":
						case "connectionclose":
						case "unknown":
							t._onPlayFailed({
								reason: "nanoPlayerPaused",
								reason2: e.data.reason,
								data: e.data
							});
							break;
					}
				}
			}
		};
	}

	isReady()
	{
		return this.ready;
	}

	isInitialized()
	{
		return this.initialized;
	}

	initialize($container, standalone = true)
	{
		logging.log(this.TAG, "initialize", this.initialized);
		if (this.initialized) return;

		this.$container = $container;

		if (standalone)
		{
			this.$container.on("mouseenter", (e) => {
				this.evt.trigger("mouseenter");
			});

			this.$container.on("mouseleave", (e) => {
				this.evt.trigger("mouseleave");
			});
		}


		this.initialized = true;

		this._onReady(null);
	}

	initPlayer()
	{
		logging.log(this.TAG, "initPlayer");

		let rootDiv = document.createElement("div");
		let id = "sxccs-nanoplayer-" + (this.playerIdNumber++);
		rootDiv.setAttribute("id", id);
		rootDiv.classList.add("sxccs-nanoplayer");
		this.$container.append(rootDiv);
		this.player = new NanoPlayer(id);
		return id;
	}

	/**
	 * This method called when the player object is ready.
	 */
	public _onReady(...args)
	{
		logging.log(this.TAG, "[_onReady]", args);
		this.ready = true;
		this.evt.trigger("ready");
	}

	/**
	 * Triggered when the playback starts after a play call
	 * @param args
	 * @private
	 */
	public _onPlaying(...args)
	{
		logging.log(this.TAG, "[_onPlaying]", args);
		this.evt.trigger("playing");
	}

	/**
	 * Triggered when the stream's dimension is changed
	 */
	public _onVideoDimension(w, h)
	{
		logging.log(this.TAG, "[_onVideoDimension]", w, h);
		this.evt.trigger("videoDimension", w, h);
	}

	public _onPlayFailed(data)
	{
		logging.log(this.TAG, "_onPlayFailed", data);

		data.stream = {
			server: this.currentServer,
			stream: this.currentStream,
		};

		this.evt.trigger("playFailed", data);
	}

	forceMute(forced: boolean): void
	{
		logging.log(this.TAG, "forceMute", forced);

		this.muteForced = forced;
		this.setVolume(this.volume);
	}

	destroy()
	{
		logging.log(this.TAG, "destroy");

		if (this.player) {
			this.player.destroy();
			this.player = null;
		}
		this.$container.empty();
		this.ready = false;
	}

	play(address: string, serverID: string, streamName: string) :void
	{
		logging.log(this.TAG, "play", address, serverID, streamName);

		if ("streamPrefix" in window) {
			streamName = window["streamPrefix"] + streamName;
		}

		if (this.player) {
			this.player.destroy();
			this.player = null;
			this.$container.empty();
		}

		this.playerID = this.initPlayer();

		const t = this;

		// var mobile = /(Android|iPhone|iPad|iPod)/.test(navigator.userAgent);
		// config.playback.autoplay = (!mobile && config.playback.autoplay);

		const onReady = () =>
		{
			logging.log(this.TAG, "play.onReady");
			const config = this.getConfig(address, streamName);

			this.currentServer = serverID;
			this.currentStream = streamName;

			this.player.setup(config).then((config) => {
				this.setVolume(this.volume);
				this.$container.css("opacity", 1);
				// this.player.play();
			}, (e) => {
				logging.log(this.TAG, "play:playerError", e);

				if (e instanceof Error) {
					t._onPlayFailed({reason: "playerSetupFailed", data: {e: e, eToString: e.toString()}})
				} else {
					t._onPlayFailed({reason: "playerSetupFailed", data: {e: e, type: typeof e}})
				}
			})
		};

		if (!this.ready) {
			logging.log(this.TAG, "play.beforeReady", serverID, streamName);
			this.evt.one("ready", onReady);
		} else {
			onReady();
		}
	}

	disconnect()
	{
		logging.log(this.TAG, "[disconnect]");
		this.stop();
	}

	setVolume(volume : number):void
	{
		logging.log(this.TAG, "setVolume", volume);
		this.volume = volume;
		if (this.player) {
			try {
				this.player.setVolume(this.muteForced ? 0 : (volume / 100));
			} catch (e) {
				// Sometimes it says player is not initialized, can't detect when that happens.
			}
		}
	}

	stop():void
	{
		logging.log(this.TAG, "Stop", this.isReady());

		if (!this.isReady()) return;

		if (this.player) {
			try {
				this.player.destroy();
			} catch (e) {
				// Sometimes it says player is not initialized, can't detect when that happens.
			}
		}
	}

	restoreLastStream() : void {
		logging.log(this.TAG, "RestoreLastStream", this.lastServer, this.lastStream);
		this.play(this.lastAddress, this.lastServer, this.lastStream);
	}

	clear()
	{
		this.$container.css("opacity", 0);
	}

	reStreamIfChanged(address: string, serverID: string, streamName: string)
	{
		if (this.currentServer && this.currentStream && this.currentServer !== serverID || this.currentStream !== streamName) {
			logging.log(this.TAG, "Stream changed", "current data", this.currentServer, this.currentStream);
			logging.log(this.TAG, "Stream changed", "new data", serverID, streamName);
			this.stop();
			this.play(address, serverID, streamName);
		}
	}

	public getVideoObject() {
		return this.player;
	}

	static getCapabilities()
	{
		return NanoPlayer.capabilities;
	}
}
